import useActiveOrDisableAccount from "./useActiveOrDisableAccount";
import {showSuccessMessage} from "@beeldit/core/helpers/messagesHelper";
import CrudModuleFactoryModal from "@beeldit/core/components/CrudModuleFactoryModal";
import {t} from "i18next";
import {useContext} from "react";
import {ActiveOrDisableActionContext} from "@beeldit/user-and-access/users/actions/active-or-disable-account/ActiveOrDisableActionContext";
import usePrepareActiveOrDisable from "@beeldit/user-and-access/users/actions/active-or-disable-account/usePrepareActiveOrDisable";

function useActiveOrDisableAccountAction(index: any): any {
  const prepareActiveOrDisable = usePrepareActiveOrDisable();
  const prepareActiveOrDisableFunction = (user: any) => prepareActiveOrDisable(user);

  const onSuccess = () => {
    showSuccessMessage("successfull_action");
    setShowModal(false);
    index();
  };

  const activeOrDisable = useActiveOrDisableAccount();
  const activeOrDisableFunction = () => activeOrDisable(onSuccess);

  const contextInstance = useContext(ActiveOrDisableActionContext);
  const { user, setShowModal } = contextInstance;

  const modalConfig = {
    contextInstance: contextInstance,
    title: user && user.status !== 1 ? "active_account" : "disable_account",
    onSubmit: () => activeOrDisableFunction(),
  };

  const actionTemplate = (
      <CrudModuleFactoryModal modalConfig={modalConfig}>
        <p>{t(user && user.status !== 1 ? "are_you_sure_you_want_to_active_account" : "are_you_sure_you_want_to_disable_account")}</p>
      </CrudModuleFactoryModal>
  );

  return {
    prepareActiveOrDisableFunction,
    actionTemplate
  };
}

export default useActiveOrDisableAccountAction;

